<!-- 由 suu 创建于 2024-02-28 星期三 -->
<template>
  <!-- 限制约课 -->
  <!-- <div class="agreement-signing-close" v-if="[8, 9].includes(type)">
  </div> -->
  <!-- 限制约课 agreement-signing-close -->
  <div
    class="agreement-signing"
    :class="{ 'agreement-signing-close': [2].includes(type) }"
  >
    <template v-if="[2].includes(type)">
      <!-- 线上 -->
      <img
        class="asc-icon-sg"
        src="https://cdnvue.gymcity.com.cn/uploads/magre-icon-signing-w"
        alt=""
      />
      <div class="asc-title">签署会员协议</div>
      <div class="asc-text">
        非常抱歉，由于您未在会员卡激活后{{
          dayText
        }}天内签署会员协议，您的约课权益暂时冻结！<span>为避免您的会员卡时长流失，</span>请您尽快从“APP-我的-签署会员协议”入口，点击签署会员协议，恢复正常约课权限。
      </div>
      <div class="asc-tips">
        如有任何疑问可咨询您的主教练或健萌长沙总部客服：0731-84484822
      </div>
    </template>
    <template v-else>
      <div class="mask-container"></div>
      <div class="animated fadeIn box-cent">
        <!-- 约课页被限制且点击预约课程 则提醒弹窗 -->
        <template v-if="type == 1">
          <img
            class="bc-icon-sg"
            src="https://cdnvue.gymcity.com.cn/uploads/magre-icon-signing-w"
            alt=""
          />
          <div class="bc-ol-title">签署会员协议</div>
          <div class="bc-ol-text">
            非常抱歉，<span>由于您暂未签署会员协议，</span>暂时无法预约会员卡激活{{
              dayText
            }}天外的课程。您可从“APP-我的-签署会员协议”入口，点击签署会员协议，签署完成后系统将完全开放您的约课权限。
          </div>
          <div class="bc-ol-btn user-btn" @click="close">我知道了</div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'coach-prove-2023',

  components: {},

  props: {
    popInfo: {}, // 弹窗信息
    scene: {}, // 显示弹窗场景  1 约课页  2 激活时
    isYyxz: {} // 点击预约课程时提示弹窗（场景为点击预约超过签署协议截止日期后的课程）
  },

  data() {
    return {
      url: '' // 协议H5
    }
  },

  computed: {
    type() {
      // 1 点击约课 日期被限制提醒弹窗，2 已被限制约课提醒整页
      if (this.scene === 1) {
        if (this.popInfo.is_reservation_class == 1) {
          // 1-限制约课，2-不限制约课
          return 2
        } else if (this.popInfo.is_reservation_class == 2 && this.isYyxz) {
          return 1
        }
      }
      return 1
    },
    dayText() {
      return this.popInfo.is_again == 1 ? 30 : 7
    }
  },

  watch: {},

  created() {
    this.getUrl()
  },

  mounted() {},

  destroyed() {},

  methods: {
    close() {
      this.$emit('on-close')
    },
    handleSigning() {
      if (this.url) {
        location.href = this.url
      } else {
        setTimeout(() => {
          this.handleSigning()
        }, 500)
      }
    },
    getUrl() {
      this.$http
        .get('member/AgreementFaDaDa?a=get_agreement', {})
        .then((res) => {
          if (res.data.code === 200) {
            this.url = res.data.data.actor_url
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.agreement-signing {
  width: 100%;
  height: 100%;
  .mask-container {
    background-color: #000;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .box-cent {
    width: vw(295);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -55%);
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    z-index: 100;
    background-color: #fff;
    padding-bottom: vw(20);
    border-radius: vw(12);
    text-align: center;
    .bc-top-bg {
      width: vw(295);
      height: vw(168);
      position: absolute;
      top: vw(-100);
      left: 0;
      z-index: -1;
    }
    .bc-text {
      width: vw(261);
      font-size: vw(13);
      color: #000;
      font-weight: 600;
      line-height: vw(20);
    }
    .bc-text-red {
      color: #dc0050;
    }
    .bc-text-exp {
      margin-top: vw(12);
      width: vw(230);
      height: vw(22);
      background: linear-gradient(#fcd9c0 0%, #ffecdf 100%);
      border-radius: vw(6);
      font-size: vw(12);
      color: #a1572d;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        color: #6236ff;
        font-weight: 600;
        margin-top: vw(2);
      }
      .icon-exp {
        width: vw(36);
        margin-left: vw(-6);
        margin-top: vw(-8);
      }
    }
    .bc-text-3 {
      font-size: vw(13);
      color: rgba(0, 0, 0, 0.8);
      line-height: vw(20);
      margin-top: vw(20);
    }
    .bc-tips {
      width: 100%;
      height: vw(165);
      margin-top: vw(12);
    }
    .bc-btns {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 vw(20);
      margin-top: vw(24);
      .b-item {
        width: vw(118);
        height: vw(44);
        box-sizing: border-box;
        border-radius: vw(22);
        border: vw(1) solid #dc0050;
        font-weight: 600;
        font-size: vw(18);
        color: #dc0050;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .b-item-c {
        background: #dc0050;
        box-shadow: vw(0) vw(2) vw(10) vw(0) rgba(220, 0, 80, 0.2);
        border: vw(2) solid #ffffff;
        color: #fff;
      }
    }
    .bc-icon-sg {
      width: vw(155);
      height: vw(130);
      margin-top: vw(16);
    }
    .bc-icon-sc {
      width: vw(101);
      height: vw(76);
      margin-top: vw(26);
      margin-bottom: vw(10);
    }
    .bc-ol-title {
      font-weight: 600;
      font-size: vw(20);
      color: #000000;
    }
    .bc-ol-text {
      width: vw(255);
      font-weight: 400;
      font-size: vw(13);
      color: rgba(0, 0, 0, 0.8);
      line-height: vw(20);
      margin-top: vw(10);
      text-align: left;
      span {
        color: #dc0050;
        font-weight: 550;
      }
    }
    .bc-ol-icon-sc {
      width: vw(237);
      margin-top: vw(10);
    }
    .bc-ol-text2 {
      font-weight: 600;
      font-size: vw(14);
      color: #000000;
      margin-top: vw(10);
    }
    .bc-ol-btn {
      width: vw(255);
      height: vw(44);
      background: #6236ff;
      border-radius: vw(22);
      font-weight: 600;
      font-size: vw(18);
      color: #ffffff;
      margin-top: vw(26);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .bc-text-2 {
      width: vw(160);
    }
    .bc-wr-tips {
      font-weight: 600;
      font-size: vw(16);
      color: #a1572d;
      position: relative;
      z-index: 1;
      margin-top: vw(4);
      margin-bottom: vw(8);
      &::after {
        content: '';
        width: 100%;
        height: vw(7);
        background: linear-gradient(#fcd9c0 0%, #ffecdf 100%);
        border-radius: vw(6);
        position: absolute;
        left: 0;
        bottom: vw(-2);
        z-index: -1;
      }
    }
  }
  .box-cent-1 {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}
.agreement-signing-close {
  width: 100%;
  min-height: 100vh;
  padding: vw(72) vw(30);
  box-sizing: border-box;
  position: relative;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  .asc-icon-sg {
    width: vw(155);
  }
  .asc-title {
    font-weight: 600;
    font-size: vw(20);
    color: #000000;
  }
  .asc-text {
    font-size: vw(14);
    margin-top: vw(16);
    line-height: vw(22);
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    span {
      color: #dc0050;
      font-weight: 600;
    }
  }
  .asc-tips {
    width: 100%;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.5);
    font-size: vw(13);
    margin-top: vw(10);
    line-height: vw(20);
  }
  .asc-btn {
    width: 100%;
    box-sizing: border-box;
    height: vw(48);
    background: #dc0050;
    box-shadow: vw(0) vw(2) vw(10) vw(0) rgba(220, 0, 80, 0.2);
    border-radius: vw(24);
    border: vw(2) solid #ffffff;
    font-weight: 600;
    font-size: vw(18);
    color: #ffffff;
    margin-top: vw(26);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
